import { useState, useEffect } from "react";
import styles from "./AllChannelPage.module.css";
import { FiSearch } from "react-icons/fi";
import { ENDPOINTS } from "../../utils/endpoints";
import api from "../../services/api";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { toast } from "react-toastify";
import useDashboardStore from "../../store/dashboardStore";
import chatStore from "../../store/chatStore";
import dayjs from "dayjs";

const AllChannels = () => {
  const { setIsCreateChannelScreen, setEditChannelId } = useDashboardStore();
  const liveUserCounts = chatStore((state) => state.liveUserCounts);
  const [channels, setChannels] = useState([]);
  const [search, setSearch] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const handleEdit = (channel) => {
    setEditChannelId(channel.id);
    setIsCreateChannelScreen();
  };

  const handleDelete = (channel) => {
    confirmAlert({
      title: "Confirm Delete",
      message: "Are you sure you want to delete this channel?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            const { data } = await api.delete(
              ENDPOINTS.DELETE_CHANNEL_BY_ID(channel.id)
            );
            if (data.success) {
              fetchChannels();
              toast.success(data.message || "Channel deleted successfully");
            }
          },
        },
        {
          label: "No",
          onClick: () => toast.error("Channel deletion cancelled"),
        },
      ],
    });
  };

  const fetchChannels = async () => {
    try {
      setIsLoading(true);
      const { data } = await api.get(ENDPOINTS.GET_ALL_CHANNELS);
      if (data.success) {
        setChannels(data.channels);
      }
    } catch (err) {
      console.error("Failed to fetch channels", err);
      toast.error("Failed to fetch channels");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchChannels();
  }, []);

  const filteredChannels = channels.filter((channel) =>
    channel.name.toLowerCase().includes(search.toLowerCase())
  );

  if (isLoading) {
    return (
      <div className={styles.container}>
        <div className={styles.appBar}>
          <h2 className={styles.title}>Channels</h2>
          <div className={styles.searchContainer}>
            <input
              type="text"
              placeholder="Type in to search .."
              className={styles.searchInput}
              disabled
            />
            <FiSearch className={styles.searchIcon} />
          </div>
        </div>
        <div className={styles.loadingContainer}>
          <div className={styles.spinner}></div>
          <p className={styles.loadingText}>Loading channels...</p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.appBar}>
        <h2 className={styles.title}>Channels</h2>
        <div className={styles.searchContainer}>
          <input
            type="text"
            placeholder="Type in to search .."
            className={styles.searchInput}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <FiSearch className={styles.searchIcon} />
        </div>
      </div>
      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Channel title</th>
              <th>Community</th>
              <th>Section</th>
              <th>Channel Type</th>
              <th>Traders</th>
              <th>Members</th>
              <th>Creation date</th>
              <th>Online</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {filteredChannels.map((comm, i) => (
              <tr key={i}>
                <td>{comm.name}</td>
                <td>{comm.community}</td>
                <td>{comm.section}</td>
                <td>{comm.is_paid === 1 ? "PAID" : "FREE"}</td>
                <td>{comm.traders_count}</td>
                <td>{comm.members_count}</td>
                <td>{dayjs(comm.created_at).format("DD-MM-YYYY")}</td>
                <td className={styles.online}>
                  {liveUserCounts[comm.id] || 0}
                </td>
                <td>
                  <span
                    className={styles.edit}
                    onClick={() => handleEdit(comm)}
                  >
                    Edit
                  </span>
                  <span className={styles.divider}> - </span>
                  <span
                    className={styles.delete}
                    onClick={() => handleDelete(comm)}
                  >
                    Delete
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AllChannels;
